import TaggedApi from '../../classes/TaggedApi';

class ContactApi extends TaggedApi {
    submit(data) {
        return this.post('/api/contact', data);
    }
}

export { ContactApi as default };
